export default __webpack_public_path__ + "static/media/blog.5f8e4494.png";